import MilitaryHero from 'assets/images/psp/hero/military-hero.webp';
import MilitaryFiveByTen from 'assets/images/psp/militarySizeGuide/unit-5x10.svg';
import MilitaryTenByTen from 'assets/images/psp/militarySizeGuide/unit-10x10.svg';
import MilitaryTenByFifteen from 'assets/images/psp/militarySizeGuide/unit-10x15.svg';
import MilitaryTenByTwenty from 'assets/images/psp/militarySizeGuide/unit-10x20.svg';
import MilitaryTenByThirty from 'assets/images/psp/militarySizeGuide/unit-10x30.svg';
import MilitaryPaperIcon from 'assets/images/psp/amenities/paperwork.svg';
import MilitaryDiscountIcon from 'assets/images/psp/save-money.svg';
import MilitaryTwentyFourHourIcon from 'assets/images/psp/amenities/24-hour.svg';
import MilitaryCameraIcon from 'assets/images/icons/psp/camera.svg';
import MilitaryMediaAndElectronicIcon from 'assets/images/icons/psp/media-electronics.svg';
import MilitaryBoxIcon1 from 'assets/images/psp/militarySizeGuide/militaryBox1.svg';
import MilitaryBoxIcon2 from 'assets/images/psp/militarySizeGuide/militaryBox2.svg';
import Featured1 from 'assets/images/psp/FeaturedImages/militaryFeatured1.webp';
import Featured2 from 'assets/images/psp/FeaturedImages/militaryFeatured2.webp';
import Featured3 from 'assets/images/psp/FeaturedImages/militaryFeatured3.webp';
import Featured4 from 'assets/images/psp/FeaturedImages/militaryFeatured4.webp';

const reviews = [
	{
		reviewTitle: 'They were so comforting in our time of need…',
		reviewRating: 5,
		reviewText:
			"They were so comforting in our time of need. My husband is in the military, and we had to move right away. We couldn't find anything, and SpareFoot came to our rescue! Wonderful and kind staff. Plus, the unit was impeccable! Couldn't ask for a better experience.",
		reviewerInitials: 'AN',

		reviewerName: 'Angie',
		reviewDate: 'Jun 13, 2021',
		link: 'https://www.trustpilot.com/reviews/60c624fdf9f4870a44d31702',
	},
	{
		reviewTitle: 'Exceptional customer service.',
		reviewRating: 5,
		reviewText:
			'Exceptional customer service. SpareFoot found us affordable pricing with a military discount, which is always greatly appreciated, and a good location.',
		reviewerInitials: 'AP',

		reviewerName: 'Ashley Portillo',
		reviewDate: 'Mar 13, 2020',
		link: 'https://www.trustpilot.com/reviews/5e6b07783c93ae091806f4f0',
	},
	{
		reviewTitle: 'Easier than I thought with SpareFoot',
		reviewRating: 5,
		reviewText:
			'I thought this was much easier than the old-fashioned way of driving around and seeing what was available. I live in a military town, so most storage is full and expensive. This gave me the actual price and availability from the comfort of my living room.',
		reviewerInitials: 'DE',

		reviewerName: 'Denise',
		reviewDate: 'Jun 8, 2021',
		link: 'https://www.trustpilot.com/users/5403c34f000064000187cb7b',
	},
	{
		reviewTitle: 'My second experience with SpareFoot …',
		reviewRating: 5,
		reviewText:
			"My second experience with SpareFoot (SF) and the outcome was the same: Awesome! I served in the military for 30 years and recognize quality. Don't waste your time calling individual storage places when SF can quickly and cheaply get you what you need!",
		reviewerInitials: 'TC',

		reviewerName: 'Tracy, Colonel (Retired) USAF',
		reviewDate: 'Aug 4, 2017',
		link: 'https://www.trustpilot.com/reviews/598462a0fba87f08a826a40d',
	},
];

const faqs = [
	{
		question: 'How much can I save with a storage unit military discount?',
		answer:
			'Military storage discounts typically range from 10-20% off standard rates, potentially saving $50-$200+ annually, depending on your unit size.\n\n' +
			"SpareFoot's facility pages display available military discounts, so you can figure out which storage facilities have the best deal for you from the comfort of home.",
	},
	{
		question: 'Do military storage discounts apply to veterans?',
		answer: 'Many facilities extend military self-storage discounts to veterans, retirees, and military spouses—always ask about eligibility when reserving.',
	},
	{
		question:
			'Can I store my POV (Personally Owned Vehicle) during deployment?',
		answer: 'Yes, military vehicle storage is available at most facilities with outdoor, covered, or enclosed options to protect your vehicle while deployed.',
	},
	{
		question:
			'What happens if I get deployment orders after signing a lease?',
		answer: 'Most military storage facilities offer flexible month-to-month terms or will waive early termination fees with proof of military orders.',
	},
	{
		question:
			'Are military storage containers better than traditional units?',
		answer: 'Military storage containers work well for PCS moves with delivery options, while traditional facilities offer better access and lower monthly costs for deployment storage.',
	},
	{
		question: 'Do I need special insurance for military storage?',
		answer: 'Standard tenant insurance covers most situations, but verify your personal property is covered during deployment—many facilities offer affordable insurance starting at $10-15/month.',
	},
];

export const MilitaryContent = {
	type: 'Military',
	sections: [
		{
			title: 'Military Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'military-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best Military Storage For You',
							image: MilitaryHero,
							description:
								"Deployment, [PCS moves](https://www.sparefoot.com/blog/military-families-pcs-move-tips), extended training… military life means being ready to move at a moment's notice. When duty calls, you need a reliable place to store your belongings without breaking your budget. Military storage facilities recognize the unique challenges faced by service members and provide flexible solutions tailored to those who serve. \n\n SpareFoot connects you with self-storage facilities near military bases across the country so that you can search, compare, and reserve in one convenient place.",
							CTAText: 'Find Military Storage',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Find Military Storage Near You',
					},
				},
			],
		},
		{
			title: 'Why Military Members Need Storage',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Why Military Members Need Storage',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'- ### During Deployment\n\n' +
								'   Store household goods, vehicles, and personal belongings securely while serving overseas, often for months or years at a time.\n\n' +
								'- ### For PCS Moves\n\n' +
								"   Bridge the gap between duty stations when your departure and arrival dates don't align, or when on-base housing isn't immediately available.\n\n" +
								'- ### Between Assignments\n\n' +
								'   Temporary duty assignments and training schools often mean [storing most belongings while living in temporary](https://www.sparefoot.com/blog/the-best-ways-to-use-storage-during-a-move) accommodations.\n\n' +
								'- ### For Military Families\n\n' +
								"   Keep children's belongings, furniture, and family items safe during relocations while maintaining stability during frequent moves.\n\n" +
								'- ### For Veterans Transitioning\n\n' +
								'   Transitioning from military to civilian life often requires temporary storage while searching for permanent housing or starting a new career.\n',
						],
					},
				},
			],
		},
		{
			title: 'Military Storage Average Pricing',
			noPadding: true,
			modules: [
				{
					type: 'content',
					props: {
						title: 'Military Storage Average Pricing',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [],
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'military-storage-pricing',
						headers: [
							{
								label: 'Unit Size',
								key: 'Unit Size',
							},
							{
								label: 'Average Monthly Price',
								key: 'Average Monthly Price',
							},
							{
								label: 'What Fits',
								key: 'What Fits',
							},
							{
								label: 'Best For',
								key: 'Best For',
							},
						],
						rows: [
							{
								'Unit Size': {
									type: 'icon',
									icon: MilitaryFiveByTen,
									description:
										'[5×10](https://www.sparefoot.com/blog/50-things-you-can-store-in-5x10-storage-unit)',
								},
								'Average Monthly Price': '$51.47',
								'What Fits':
									'Dorm room, small apartment, personal items',
								'Best For':
									'Single service member, basic deployment storage',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: MilitaryTenByTen,
									description:
										'[10×10](https://www.sparefoot.com/blog/10x10-storage-unit-size-guide)',
								},
								'Average Monthly Price': '$82.81',
								'What Fits':
									'One-bedroom apartment, motorcycle',
								'Best For': 'Junior enlisted, small family',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: MilitaryTenByFifteen,
									description:
										'[10×15](https://www.sparefoot.com/blog/what-can-you-fit-inside-of-a-10x15-storage-unit)',
								},
								'Average Monthly Price': '$109.48',
								'What Fits': 'Two-bedroom home, vehicle',
								'Best For': 'Mid-size family, PCS transition',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: MilitaryTenByTwenty,
									description:
										'[10×20](https://www.sparefoot.com/blog/10x20-storage-unit-size-guide)',
								},
								'Average Monthly Price': '$132.43',
								'What Fits': 'Three-bedroom house, boat, car',
								'Best For':
									'Larger family, extended deployment',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: MilitaryTenByThirty,
									description:
										'[10×30](https://www.sparefoot.com/blog/10x30-storage-unit-size-guide)',
								},
								'Average Monthly Price': '$165.85',
								'What Fits':
									'Four-bedroom house, multiple vehicles',
								'Best For':
									'Senior enlisted/officer families, long-term storage',
							},
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'*Pricing based on average rates across SpareFoot.com facilities; military discounts may be available. You can find military discount availability under the Discounts section of facility pages.*',
						],
					},
				},
			],
		},
		{
			title: 'What Military Personnel Should Look For',
			noPaddingBottom: true,
			modules: [
				{
					type: 'content',
					props: {
						title: 'What Military Personnel Should Look For',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [],
					},
				},
				{
					type: 'unitList',
					props: {
						slug: 'military-personnel-features',
						headerLink: '#military-personnel-features',
						scrollFactor: 0.8,
						unitsData: [
							{
								image: MilitaryPaperIcon,
								content:
									'### Flexible Lease Terms\n\n' +
									'Month-to-month leases accommodate sudden deployment orders or unexpected PCS moves without penalty for early termination.',
								newlayout: false,
							},
							{
								image: MilitaryDiscountIcon,
								content:
									'### Verified Military Discounts\n\n' +
									'Look for facilities offering storage unit military discount programs requiring military ID or proof of service—savings of 10-20% can add up significantly during long-term storage.',
								newlayout: false,
							},
							{
								image: MilitaryTwentyFourHourIcon,
								content:
									'### Vehicle Storage Options\n\n' +
									'Many military members [need to store cars, motorcycles, or boats](https://www.sparefoot.com/blog/how-to-store-a-car-long-term) during deployment. Military vehicle storage with covered or enclosed options protects your investment.',
								newlayout: false,
							},
							{
								image: MilitaryCameraIcon,
								content:
									'### Enhanced Security\n\n' +
									"24-hour surveillance, gated access, and individual unit alarms provide peace of mind while you're serving away from home.",
								newlayout: false,
							},
							{
								image: MilitaryMediaAndElectronicIcon,
								content:
									'### Online Account Management\n\n' +
									'Pay bills, extend leases, and manage your unit remotely while deployed or stationed overseas.',
								newlayout: false,
							},
						],
					},
				},
			],
		},
		{
			title: 'Military Storage Container vs. Facility Storage',
			noPadding: true,
			modules: [
				{
					type: 'content',
					props: {
						title: 'Military Storage Container vs. Facility Storage',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [],
					},
				},
				{
					type: 'unitList',
					props: {
						slug: 'military-storage-comparison',
						headerLink: '#military-storage-comparison',
						scrollFactor: 0.8,
						unitsData: [
							{
								image: MilitaryBoxIcon1,
								content:
									'### Military Storage Containers (Portable)\n\n' +
									'- Delivered to your location for self-packing\n\n' +
									'- Stored at the company facility or transported to a new location\n' +
									'- Great for PCS moves with direct delivery options\n' +
									'- Typically $150-$300/month, depending on size and distance\n' +
									'- **Best For:** PCS Moves',
								newlayout: false,
							},
							{
								image: MilitaryBoxIcon2,
								content:
									'### Military Storage Facility (Traditional)\n\n' +
									'- Drive-up or interior units at fixed locations\n\n' +
									'- Access your belongings anytime with 24/7 options\n' +
									'- Better for local storage during deployment\n' +
									'- Average $70-$119/month with military discounts\n' +
									'- **Best For:** Deployment or storage for families during relocations',
								newlayout: false,
							},
						],
					},
				},
			],
		},
		{
			title: 'What You Need To Rent A Military Storage Unit',
			modules: [
				{
					type: 'content',
					props: {
						title: 'What You Need To Rent A Military Storage Unit',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'### To Qualify for Military Discounts:\n\n' +
								'- Active duty military ID\n\n' +
								'- Veteran ID card or DD-214\n\n' +
								'- Military spouse ID (some facilities)\n\n' +
								'- Reserve/National Guard ID\n',
							'### For Vehicle Storage:\n\n' +
								'- Current vehicle registration\n\n' +
								'- Proof of insurance\n\n' +
								"- Valid driver's license\n\n" +
								'- Military orders (some facilities waive deposits with orders)\n',
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: 'Get the Best Prices & Flexibility for Military Storage with SpareFoot',
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Military Storage FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'rv-featured-content',
						contentCards: [
							{
								title: 'Moving Tips',
								date: 'October 27, 2025',
								image: Featured1,
								content:
									'Your First Military PCS Move: Everything You Need to Know',
								link: 'https://www.sparefoot.com/blog/military-families-pcs-move-tips',
							},
							{
								title: 'Moving Tips',
								date: 'January 15, 2025',
								image: Featured2,
								content:
									'Moving Truck Rental Cost: Pricing Factors + Best Options in 2025',
								link: 'https://www.sparefoot.com/blog/moving-truck-rental-cost',
							},
							{
								title: 'Moving Tips',
								date: 'October 27, 2025',
								content:
									'Temporary Storage in Between Moves: A Comprehensive Guide',
								link: 'https://www.sparefoot.com/blog/temporary-storage-between-moves',
								image: Featured3,
							},
							{
								title: 'Moving Tips',
								date: 'October 27, 2025',
								content:
									'Top Moving Discounts and Deals To Reduce Your Moving Costs in 2025',
								link: 'https://www.sparefoot.com/blog/moving-discounts',
								image: Featured4,
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'ClimateControl',
							'24Hour',
							'Portable',
							'Car',
							'RV',
							'Motorcycle',
							'Boat',
							'Vehicle',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
	storageType: 'Military',
};
